import { Action } from './core/action';

export class PayByPaycellAction implements Action {
  constructor(public paymentMethodId: number, public cardId:string) {}
}



// WEBPACK FOOTER //
// src/app/common/actions/pay-by-paycell.action.ts